import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

	transform(arr: Array<any>, prop: string, reverse: boolean = false): any {
		if (prop != undefined && prop != "") {
			if (arr === undefined) return
			const m = reverse ? -1 : 1
			return arr.sort((a: any, b: any): number => {
				const x = eval("a." + prop);
				const y = eval("b." + prop);
				if (this.typeOf(x) == "string") {
					return (x.toLowerCase() === y.toLowerCase()) ? 0 : (x.toLowerCase() < y.toLowerCase()) ? -1 * m : 1 * m
				}
				else {
					return (x === y) ? 0 : (x < y) ? -1 * m : 1 * m
				}

			})
		}
		else {
			return arr;
		}

	}

	typeOf(obj) {
		return {}.toString.call(obj).split(' ')[1].slice(0, -1).toLowerCase();
	}

}



// WEBPACK FOOTER //
// ./src/app/pipes/sort-by.pipe.ts